import { ActivityLogGroupingInterval } from '../../../../../constants'
import { useIntl } from 'react-intl'
import { useMemo } from 'react'

export const useGroupingIntervalOptions = () => {
  const intl = useIntl()

  const groupingIntervalOptions = useMemo(() => {
    return Object.keys(ActivityLogGroupingInterval).map((interval) => ({
      key: ActivityLogGroupingInterval[interval],
      value: ActivityLogGroupingInterval[interval],
      label: intl.formatMessage({
        id: `dataSources.widget.companyWideActivity.groupingInterval.${ActivityLogGroupingInterval[
          interval
        ].toLowerCase()}`
      })
    }))
  }, [intl])

  return groupingIntervalOptions
}
